<template>
  <div class="wrapper">
    <h1 class="banner-title">{{ $t('home.merch.sector4.title') }}</h1>
    <BannerSearch />
    <div class="banner-brands">
      <h2 class="subtitle">{{ $t('home.merch.header.subtitle') }}</h2>
      <div class="banner-brands-row">
        <BrandsBlock :padding="7" :inline-desktop="true" :brands="brands" />
      </div>
    </div>
  </div>
</template>

<script>
import BannerSearch from '../BannerSearch';
import BrandsBlock from '@/components/Common/BrandsBlock';

export default {
  name: 'MerchBannerContent',
  components: {
    BannerSearch,
    BrandsBlock
  },
  data: () => {
    return {
      brands: [
        {
          src: 'https://cdn.vexels.com/img/licensed-brands/merch-by-amazon.png',
          alt: 'Merch by amazon'
        },
        { src: 'https://cdn.vexels.com/img/licensed-brands/printful.png', alt: 'Printful' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/redbubble.png', alt: 'Redbubble' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/teespring.png', alt: 'Teespring' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/etsy.png', alt: 'Etsy' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/zazzle.png', alt: 'Zazzle' },
        { src: 'https://cdn.vexels.com/img/licensed-brands/more.png', alt: 'More' }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.banner-title {
  font-weight: 400;
  line-height: 1.5;
  color: white;
  font-size: 42px;
  text-align: center;
  margin-bottom: 40px;
  @include xl2 {
    font-size: 32px;
    margin-bottom: 32px;
  }
  @include xl {
    margin-bottom: 24px;
  }
  @include lg {
    font-size: 24px;
    width: 70%;
    margin-bottom: 16px;
  }
  @include md {
    width: 80%;
  }
  @include sm {
    width: 90%;
    font-size: 20px;
  }
}
.banner-brands {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 105%;
  .subtitle {
    font-size: 16px;
    margin-top: 16px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
    @include lg {
      margin-top: 24px;
      font-size: 12px;
    }
    @include sm {
      font-size: 8px;
    }
  }
  .banner-brands-row {
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    img {
      position: relative;
      z-index: 100;
      min-width: 100%;
      height: auto;
      @include lg {
        margin-bottom: 12px;
        display: none;
      }
    }
  }
}
</style>
